// Tier is derived from price_per_night, matching the partner tier bands:
// Tier 1 = S$200++, Tier 2 = S$80-110, Tier 3 = S$40-79.
function tierFromPrice(price) {
  if (price >= 200) return 1;
  if (price >= 80) return 2;
  return 3;
}

const RAW_HOTELS = [
  // Batam Hills Golf Resort partners (in ferry-terminal order: Sekupang, HarbourBay, Batam Centre)
  {
    id: "h_bh_sekupang",
    name: "Aston Batam Hotel and Residence",
    area: "Sekupang Area",
    price_per_night: 62,
    rating: 4.3,
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    description: "A well-located residence-style hotel near Sekupang Ferry Terminal, offering spacious rooms and easy access to Batam's western golf courses.",
    amenities: ["Free Wi-Fi", "Swimming Pool", "Restaurant", "Fitness Center"],
    room_type: "Deluxe Room",
  },
  {
    id: "h_bh_harbourbay",
    name: "iHotel Nagoya Hill",
    area: "Harbourbay Area",
    price_per_night: 72,
    rating: 4.4,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
    description: "A modern mid-range hotel close to Harbourbay Ferry Terminal and Nagoya Hill Mall, popular with golfers passing through Batam Hills.",
    amenities: ["Free Wi-Fi", "Restaurant", "Mall Access", "24hr Front Desk"],
    room_type: "Superior Room",
  },
  {
    id: "h_bh_batamcentre",
    name: "Planet Holiday Hotel & Residence",
    area: "Batam Centre Area",
    price_per_night: 41,
    rating: 4.1,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    description: "A budget-friendly residence hotel in Batam Centre, a short ride from Batam Centre Ferry Terminal.",
    amenities: ["Free Wi-Fi", "Restaurant", "24hr Front Desk"],
    room_type: "Standard Room",
  },
  // Southlinks Country Club partners
  {
    id: "h_sl_sekupang",
    name: "AP Premier Batam",
    area: "Sekupang Area",
    price_per_night: 44,
    rating: 4.0,
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80",
    description: "A practical, affordable hotel near Sekupang Ferry Terminal, convenient for a quick golf getaway.",
    amenities: ["Free Wi-Fi", "Restaurant", "Airport Transfer"],
    room_type: "Standard Room",
  },
  {
    id: "h_sl_harbourbay",
    name: "Pacific Palace Hotel",
    area: "Harbourbay Area",
    price_per_night: 47,
    rating: 4.5,
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800&q=80",
    description: "Located in the heart of Harbourbay, Pacific Palace Hotel offers modern comfort with easy access to ferry terminals and major golf courses.",
    amenities: ["Free Wi-Fi", "Swimming Pool", "Restaurant", "Business Center"],
    room_type: "Deluxe Room",
  },
  {
    id: "h_sl_batamcentre",
    name: "Asialink Hotel by Prasanthi",
    area: "Batam Centre Area",
    price_per_night: 52,
    rating: 4.1,
    image: "https://images.unsplash.com/photo-1590073242678-70ee3fc28f8e?w=800&q=80",
    description: "A comfortable hotel in Batam Centre with easy access to the ferry terminal and shopping district.",
    amenities: ["Free Wi-Fi", "Restaurant", "Fitness Center"],
    room_type: "Superior Room",
  },
  // Indah Puri Golf Resort partners
  {
    id: "h_ip_sekupang",
    name: "HARRIS Hotel Batam Center",
    area: "Sekupang Area",
    price_per_night: 55,
    rating: 4.4,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
    description: "A well-regarded HARRIS property offering reliable comfort and easy transfers to Batam's golf courses.",
    amenities: ["Free Wi-Fi", "Swimming Pool", "Restaurant", "Gym"],
    room_type: "Superior Room",
  },
  {
    id: "h_ip_harbourbay",
    name: "Nagoya Hill Hotel Batam",
    area: "Harbourbay Area",
    price_per_night: 63,
    rating: 4.2,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    description: "A convenient hotel near Nagoya Hill and Harbourbay Ferry Terminal, close to Indah Puri Golf Resort.",
    amenities: ["Free Wi-Fi", "Restaurant", "Mall Access"],
    room_type: "Deluxe Room",
  },
  {
    id: "h_ip_batamcentre",
    name: "ibis Styles Batam Nagoya",
    area: "Batam Centre Area",
    price_per_night: 50,
    rating: 4.3,
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    description: "A stylish, well-priced ibis property in Batam Centre with a short ride to Indah Puri Golf Resort.",
    amenities: ["Free Wi-Fi", "Swimming Pool", "Restaurant"],
    room_type: "Standard Room",
  },
  // Padang Golf Sukajadi partners
  {
    id: "h_pg_sekupang",
    name: "Radisson Golf and Convention Center Batam",
    area: "Sekupang Area",
    price_per_night: 132,
    rating: 4.7,
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    description: "An upscale golf resort hotel directly connected to premium facilities, ideal for golfers wanting on-site convenience.",
    amenities: ["Free Wi-Fi", "Swimming Pool", "Spa", "Golf Course Access", "Fine Dining"],
    room_type: "Executive Suite",
  },
  {
    id: "h_pg_harbourbay",
    name: "Kings Hotel Nagoya Batam",
    area: "Harbourbay Area",
    price_per_night: 29,
    rating: 3.9,
    image: "https://images.unsplash.com/photo-1590073242678-70ee3fc28f8e?w=800&q=80",
    description: "A no-frills budget hotel near Harbourbay, a practical base for a short golf day-trip.",
    amenities: ["Free Wi-Fi", "24hr Front Desk"],
    room_type: "Standard Room",
  },
  {
    id: "h_pg_batamcentre",
    name: "Golden View Hotel Batam",
    area: "Batam Centre Area",
    price_per_night: 34,
    rating: 4.0,
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80",
    description: "An affordable hotel in Batam Centre with easy access to the ferry terminal.",
    amenities: ["Free Wi-Fi", "Restaurant"],
    room_type: "Standard Room",
  },
  // Palm Springs Golf & Country Club / Batam Island Country Club (BICC) — shared Nongsa partners
  {
    id: "h_ng_batamview",
    name: "Batam View Resort",
    area: "Nongsa Area",
    price_per_night: 68,
    rating: 4.3,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
    description: "A relaxed beachfront resort in Nongsa, minutes from Palm Springs and BICC's fairways.",
    amenities: ["Beach Access", "Swimming Pool", "Free Wi-Fi", "Restaurant"],
    room_type: "Garden Room",
  },
  {
    id: "h_ng_turibeach",
    name: "Turi Beach Resort",
    area: "Nongsa Area",
    price_per_night: 87,
    rating: 4.5,
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    description: "A well-established beach resort with tropical grounds, close to Nongsa's golf courses.",
    amenities: ["Beach Access", "Swimming Pool", "Free Wi-Fi", "Spa", "Restaurant"],
    room_type: "Deluxe Room",
  },
  {
    id: "h_ng_marina",
    name: "Nongsa Point Marina & Resort",
    area: "Nongsa Area",
    price_per_night: 67,
    rating: 4.4,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    description: "A marina-side resort in Nongsa with waterfront views, a short drive from Palm Springs and BICC.",
    amenities: ["Marina View", "Swimming Pool", "Free Wi-Fi", "Restaurant"],
    room_type: "Superior Room",
  },
  {
    id: "h_ng_nuvasa",
    name: "Nuvasa Bay Apartments",
    area: "Nongsa Area",
    price_per_night: 58,
    rating: 4.2,
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800&q=80",
    description: "Serviced apartments overlooking Nuvasa Bay, offering a spacious and self-sufficient stay near Nongsa's golf courses.",
    amenities: ["Kitchenette", "Free Wi-Fi", "Swimming Pool", "Balcony"],
    room_type: "1-Bedroom Apartment",
  },
];

export const ACCOMMODATIONS = RAW_HOTELS.map((h) => ({ ...h, tier: tierFromPrice(h.price_per_night) }));
